import { FC, ReactNode } from "react";
import styled from "styled-components";

const HeaderRow = styled.div`
	display: grid;
	grid-template-columns: max-content max-content;
	justify-content: space-between;
`;

interface BaseAttributeCardProps {
	labels?: ReactNode;
	active: boolean;
	heading: string;
	value: ReactNode;
	onClick: () => void;
}

const CardWrapper = styled.div<{ $active: boolean }>`
	cursor: pointer;
	border-width: ${({ $active }) => ($active ? "2px" : "1px")};
	border-style: solid;
	border-radius: ${({ theme }) => theme.spacing(1)};
	border-color: ${({ theme, $active }) =>
		$active ? theme.colors.palette.primary.main.base : theme.colors.palette.grey[20]};
`;

const CardContent = styled.div<{ $active: boolean }>`
	border: ${({ $active }) => ($active ? "none" : "1px solid transparent")};
	padding: ${({ theme }) => theme.spacing(4)};
	display: grid;
	grid-auto-flow: row;
	grid-auto-rows: max-content;
	gap: ${({ theme }) => theme.spacing(2)};
`;

const Labels = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spacing(1)};
`;

export const ContactUpdateBaseDiffCard: FC<BaseAttributeCardProps> = ({ active, heading, value, labels, onClick }) => {
	return (
		<CardWrapper $active={active} onClick={onClick}>
			<CardContent $active={active}>
				<HeaderRow>
					<b>{heading}</b>
					{labels && <Labels>{labels}</Labels>}
				</HeaderRow>
				{value}
			</CardContent>
		</CardWrapper>
	);
};
